export enum ServerError {
  Unhandled,
  Unauthorized,
  Forbidden,
}
